import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-global-modal',
  templateUrl: './global-modal.component.html',
  styleUrls: ['./global-modal.component.scss'],
})
export class GlobalModalComponent implements OnInit {
  public message: string;
  public confirmMode: boolean;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    if (this.config && this.config.data) {
      this.message = this.config.data.message;
      this.confirmMode = this.config.data.confirmMode;
    }
  }

  public close(result?: string): void {
    this.ref.close(result);
  }
}
